module.exports = __webpack_public_path__ + "static/neon-sun-logo-659e91f764d904b2cbe92a45e4239c92.png";